import React from 'react';

function ItemRow({ item, onIncrement, onDecrement,checkBoxSelect,checkedItemsList }) {

  return (
    <div className="table-row flexRow justifyContentSpaceBetween">
<div className='flexRow justifyContentFlexStart'>
    <span className='flexCol  justifyContentCenter alignItemsCenter'><input checked={checkedItemsList?.includes(item.itemId)} onChange={(e)=>checkBoxSelect(e,item.itemId)} type="checkbox" className='margRight10'/> </span>
      <div className="item-info">
        <div className='margBottom5'>{item.itemName}</div>
        <div className="item-id">{item.itemCode}</div>
      </div>
</div>
      <div className="counter">
        <button onClick={onDecrement}>-</button>
        <span>{item.totalUplifted??0}</span>
        <button onClick={onIncrement}>+</button>
      </div>
    </div>
  );
}

export default ItemRow;
